module.exports = __webpack_public_path__ + "img/yaoyuxin.a048de5d.jpg";